import reactLogo from "./stack-images/react2.png";
import jsLogo from "./stack-images/js.png";
import nodejsLogo from "./stack-images/nodejs.png";
import mongodbLogo from "./stack-images/mongodb.png";
import sassLogo from "./stack-images/sass.png";
import htmlLogo from "./stack-images/html.png";
import cssLogo from "./stack-images/css.png";
import expressLogo from "./stack-images/express.png";
import gitLogo from "./stack-images/git.png";
import githubLogo from "./stack-images/github.png";
import vscodeLogo from "./stack-images/vscode.png";

const technos = [
  {
    name: "React",
    type: "front",
    img: reactLogo,
  },
  {
    name: "Javascript",
    type: "front",
    img: jsLogo,
  },
  {
    name: "MongoDB",
    type: "back",
    img: mongodbLogo,
  },
  {
    name: "NodeJs",
    type: "back",
    img: nodejsLogo,
  },
  {
    name: "Sass",
    type: "front",
    img: sassLogo,
  },
  {
    name: "HTML5",
    type: "front",
    img: htmlLogo,
  },
  {
    name: "CSS3",
    type: "front",
    img: cssLogo,
  },
  {
    name: "Express",
    type: "back",
    img: expressLogo,
  },
  {
    name: "Git",
    type: "tool",
    img: gitLogo,
  },
  {
    name: "GitHub",
    type: "tool",
    img: githubLogo,
  },
  {
    name: "VS Code",
    type: "tool",
    img: vscodeLogo,
  },
];

export default technos;
